module.exports = __webpack_public_path__ + "img/down-arrow1.de8dad13.svg";